import { render, staticRenderFns } from "./ModulesIndex.vue?vue&type=template&id=73e550b8"
import script from "./ModulesIndex.vue?vue&type=script&lang=js"
export * from "./ModulesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports